import React, { useState } from 'react';
import { createPortal } from 'react-dom';

const PasswordDialog = ({ isOpen, onClose, onSuccess, title = "Khu vực bảo mật", section = "mlops" }) => {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [showPassword, setShowPassword] = useState(false);

  // Different passwords for different sections
  const getCorrectPassword = (sectionType) => {
    switch(sectionType) {
      case 'mlops':
        return 'hoctapchamchi123#asd!';
      case 'ai':
        return 'hoctapaichamchi123';
      default:
        return 'hoctapchamchi123#asd!';
    }
  };

  const CORRECT_PASSWORD = getCorrectPassword(section);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (password === CORRECT_PASSWORD) {
      // Store authentication in localStorage with section-specific key
      localStorage.setItem(`auth_${section}`, new Date().getTime().toString());
      setError('');
      setPassword('');
      onSuccess();
    } else {
      setError('Mật khẩu không đúng. Vui lòng thử lại.');
      setPassword('');
    }
  };

  const handleClose = () => {
    setPassword('');
    setError('');
    setShowPassword(false);
    onClose();
  };

  if (!isOpen) return null;

  return createPortal(
    <div className="fixed inset-0 bg-black/80 backdrop-blur-sm z-[9999]">
      <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-black/90 border border-red-400/50 rounded-2xl shadow-neon-pink p-6 sm:p-8 w-[90vw] max-w-lg overflow-hidden">
        {/* Cyberpunk animated border */}
        <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-red-400 to-transparent animate-slide-right rounded-t-2xl"></div>
        <div className="absolute -top-20 -right-20 w-40 h-40 bg-gradient-to-br from-red-400/20 to-pink-400/20 rounded-full blur-3xl"></div>
        
        {/* Header */}
        <div className="text-center mb-6 sm:mb-8 relative z-10">
          <div className="w-16 h-16 sm:w-20 sm:h-20 bg-black/60 border-2 border-red-400 rounded-2xl flex items-center justify-center mx-auto mb-4 sm:mb-6 shadow-neon-pink group hover:scale-110 transition-transform duration-300">
            <svg className="w-6 h-6 sm:w-8 sm:h-8 text-red-400 group-hover:text-pink-400 transition-colors duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
            </svg>
            <div className="absolute inset-0 rounded-2xl"></div>
          </div>
          <h2 className="text-xl sm:text-2xl font-black font-mono text-transparent bg-clip-text bg-gradient-to-r from-red-400 via-pink-500 to-orange-400 mb-2 sm:mb-3 animate-gradient-x">
            SECURITY PROTOCOL
          </h2>
          <p className="text-gray-300 font-mono text-xs sm:text-sm px-2">
            <span className="text-red-400">{'>'}</span> {section === 'ai' ? 'AI_MODULE requires authorization' : 'AI&MLOPS_MODULE requires authorization'}
            {/* <span className="animate-blink text-red-400">█</span> */}
          </p>
        </div>

        {/* Password Form */}
        <form onSubmit={handleSubmit} className="space-y-4 sm:space-y-6 relative z-10">
          <div>
            {/* <label htmlFor="password" className="block text-xs sm:text-sm font-mono font-medium text-gray-300 mb-2 sm:mb-3 items-center">
              AUTH INPUT
            </label> */}
            <div className="relative">
              <input
                type={showPassword ? "text" : "password"}
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full px-3 py-3 sm:px-4 sm:py-4 bg-black/60 border border-red-400/50 rounded-xl text-white placeholder-gray-500 font-mono text-sm focus:ring-2 focus:ring-red-400 focus:border-transparent outline-none transition-all duration-300 shadow-neon-pink"
                placeholder="Enter authorization code..."
                required
                autoFocus
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                className="absolute right-3 sm:right-4 top-1/2 transform -translate-y-1/2 text-red-400 hover:text-pink-400 transition-colors duration-300"
              >
                {showPassword ? (
                  <svg className="w-4 h-4 sm:w-5 sm:h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.878 9.878L3 3m6.878 6.878L21 21" />
                  </svg>
                ) : (
                  <svg className="w-4 h-4 sm:w-5 sm:h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                  </svg>
                )}
              </button>
            </div>
          </div>

          {error && (
            <div className="bg-red-500/20 border border-red-400/50 rounded-xl p-4 backdrop-blur-sm">
              <div className="flex items-center">
                <svg className="w-5 h-5 text-red-400 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                <p className="text-red-300 text-sm font-mono">ERROR {error}</p>
              </div>
            </div>
          )}

          <div className="flex flex-col sm:flex-row space-y-3 sm:space-y-0 sm:space-x-4">
            <button
              type="button"
              onClick={handleClose}
              className="group relative flex-1 px-4 py-3 bg-transparent border-2 border-gray-500 text-gray-400 rounded-xl font-mono font-bold hover:shadow-neon-gray transition-all duration-300 transform hover:scale-105 overflow-hidden text-sm"
            >
              <span className="relative z-10">CANCEL</span>
              <div className="absolute inset-0 bg-gray-500 rounded-xl transform -skew-x-12 scale-x-0 group-hover:scale-x-100 transition-transform duration-500 opacity-20"></div>
            </button>
            <button
              type="submit"
              className="group relative flex-1 bg-transparent border-2 border-red-400 text-red-400 py-3 px-4 rounded-xl font-mono font-bold shadow-neon-pink hover:shadow-neon-pink-intense transition-all duration-300 transform hover:scale-105 overflow-hidden text-sm"
            >
              <span className="relative z-10">AUTHENTICATE</span>
              <div className="absolute inset-0 bg-red-400 rounded-xl transform skew-x-12 scale-x-0 group-hover:scale-x-100 transition-transform duration-500 opacity-20"></div>
              <div className="absolute inset-0 border border-red-400 rounded-xl animate-border-pulse"></div>
            </button>
          </div>
        </form>

        {/* Info */}
        <div className="mt-4 sm:mt-6 p-3 sm:p-4 bg-black/40 border border-cyan-400/20 rounded-xl backdrop-blur-sm relative z-10">
          <div className="flex items-start">
            <svg className="w-3 h-3 sm:w-4 sm:h-4 text-cyan-400 mr-2 sm:mr-3 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            <div>
              <p className="text-xs text-gray-400 font-mono leading-relaxed">
                {'>'} Session valid for 24 hours<br/>
                {'>'} Authorized personnel only<br/>
                {'>'} Unauthorized access will be <span className="text-red-400">TERMINATED</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default PasswordDialog; 